/* tslint:disable */
/* eslint-disable */
/**
 * RZPV API
 * API rozklikávacího rozpočtu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { EnumPlanObdobi } from '../model';
// @ts-ignore
import { PlanDetailVO } from '../model';
// @ts-ignore
import { PlanVO } from '../model';
/**
 * SouhrnControllerApi - axios parameter creator
 * @export
 */
export const SouhrnControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSouhrnExportFile: async (fileId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('downloadSouhrnExportFile', 'fileId', fileId)
            const localVarPath = `/api/rzpv/souhrn/export/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} idPlanVerze 
         * @param {EnumPlanObdobi} planObdobi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSouhrn: async (idPlanVerze: number, planObdobi: EnumPlanObdobi, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPlanVerze' is not null or undefined
            assertParamExists('exportSouhrn', 'idPlanVerze', idPlanVerze)
            // verify required parameter 'planObdobi' is not null or undefined
            assertParamExists('exportSouhrn', 'planObdobi', planObdobi)
            const localVarPath = `/api/rzpv/souhrn/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idPlanVerze !== undefined) {
                localVarQueryParameter['idPlanVerze'] = idPlanVerze;
            }

            if (planObdobi !== undefined) {
                localVarQueryParameter['planObdobi'] = planObdobi;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKomentar: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/rzpv/souhrn/komentar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} idPlanVerze 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrubeh: async (idPlanVerze: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPlanVerze' is not null or undefined
            assertParamExists('getPrubeh', 'idPlanVerze', idPlanVerze)
            const localVarPath = `/api/rzpv/souhrn/prubeh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idPlanVerze !== undefined) {
                localVarQueryParameter['idPlanVerze'] = idPlanVerze;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} idPlanVerze 
         * @param {EnumPlanObdobi} planObdobi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSouhrn: async (idPlanVerze: number, planObdobi: EnumPlanObdobi, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPlanVerze' is not null or undefined
            assertParamExists('getSouhrn', 'idPlanVerze', idPlanVerze)
            // verify required parameter 'planObdobi' is not null or undefined
            assertParamExists('getSouhrn', 'planObdobi', planObdobi)
            const localVarPath = `/api/rzpv/souhrn`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idPlanVerze !== undefined) {
                localVarQueryParameter['idPlanVerze'] = idPlanVerze;
            }

            if (planObdobi !== undefined) {
                localVarQueryParameter['planObdobi'] = planObdobi;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SouhrnControllerApi - functional programming interface
 * @export
 */
export const SouhrnControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SouhrnControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSouhrnExportFile(fileId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSouhrnExportFile(fileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} idPlanVerze 
         * @param {EnumPlanObdobi} planObdobi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportSouhrn(idPlanVerze: number, planObdobi: EnumPlanObdobi, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportSouhrn(idPlanVerze, planObdobi, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKomentar(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKomentar(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} idPlanVerze 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrubeh(idPlanVerze: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanDetailVO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrubeh(idPlanVerze, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} idPlanVerze 
         * @param {EnumPlanObdobi} planObdobi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSouhrn(idPlanVerze: number, planObdobi: EnumPlanObdobi, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanVO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSouhrn(idPlanVerze, planObdobi, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SouhrnControllerApi - factory interface
 * @export
 */
export const SouhrnControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SouhrnControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSouhrnExportFile(fileId: string, options?: any): AxiosPromise<any> {
            return localVarFp.downloadSouhrnExportFile(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} idPlanVerze 
         * @param {EnumPlanObdobi} planObdobi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSouhrn(idPlanVerze: number, planObdobi: EnumPlanObdobi, options?: any): AxiosPromise<string> {
            return localVarFp.exportSouhrn(idPlanVerze, planObdobi, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKomentar(options?: any): AxiosPromise<string> {
            return localVarFp.getKomentar(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} idPlanVerze 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrubeh(idPlanVerze: number, options?: any): AxiosPromise<Array<PlanDetailVO>> {
            return localVarFp.getPrubeh(idPlanVerze, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} idPlanVerze 
         * @param {EnumPlanObdobi} planObdobi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSouhrn(idPlanVerze: number, planObdobi: EnumPlanObdobi, options?: any): AxiosPromise<Array<PlanVO>> {
            return localVarFp.getSouhrn(idPlanVerze, planObdobi, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SouhrnControllerApi - interface
 * @export
 * @interface SouhrnControllerApi
 */
export interface SouhrnControllerApiInterface {
    /**
     * 
     * @param {string} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouhrnControllerApiInterface
     */
    downloadSouhrnExportFile(fileId: string, options?: any): AxiosPromise<any>;

    /**
     * 
     * @param {number} idPlanVerze 
     * @param {EnumPlanObdobi} planObdobi 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouhrnControllerApiInterface
     */
    exportSouhrn(idPlanVerze: number, planObdobi: EnumPlanObdobi, options?: any): AxiosPromise<string>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouhrnControllerApiInterface
     */
    getKomentar(options?: any): AxiosPromise<string>;

    /**
     * 
     * @param {number} idPlanVerze 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouhrnControllerApiInterface
     */
    getPrubeh(idPlanVerze: number, options?: any): AxiosPromise<Array<PlanDetailVO>>;

    /**
     * 
     * @param {number} idPlanVerze 
     * @param {EnumPlanObdobi} planObdobi 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouhrnControllerApiInterface
     */
    getSouhrn(idPlanVerze: number, planObdobi: EnumPlanObdobi, options?: any): AxiosPromise<Array<PlanVO>>;

}

/**
 * SouhrnControllerApi - object-oriented interface
 * @export
 * @class SouhrnControllerApi
 * @extends {BaseAPI}
 */
export class SouhrnControllerApi extends BaseAPI implements SouhrnControllerApiInterface {
    /**
     * 
     * @param {string} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouhrnControllerApi
     */
    public downloadSouhrnExportFile(fileId: string, options?: any) {
        return SouhrnControllerApiFp(this.configuration).downloadSouhrnExportFile(fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} idPlanVerze 
     * @param {EnumPlanObdobi} planObdobi 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouhrnControllerApi
     */
    public exportSouhrn(idPlanVerze: number, planObdobi: EnumPlanObdobi, options?: any) {
        return SouhrnControllerApiFp(this.configuration).exportSouhrn(idPlanVerze, planObdobi, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouhrnControllerApi
     */
    public getKomentar(options?: any) {
        return SouhrnControllerApiFp(this.configuration).getKomentar(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} idPlanVerze 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouhrnControllerApi
     */
    public getPrubeh(idPlanVerze: number, options?: any) {
        return SouhrnControllerApiFp(this.configuration).getPrubeh(idPlanVerze, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} idPlanVerze 
     * @param {EnumPlanObdobi} planObdobi 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SouhrnControllerApi
     */
    public getSouhrn(idPlanVerze: number, planObdobi: EnumPlanObdobi, options?: any) {
        return SouhrnControllerApiFp(this.configuration).getSouhrn(idPlanVerze, planObdobi, options).then((request) => request(this.axios, this.basePath));
    }
}
